<template>
  <div class="wrapper">
    <div class="content">
      <div class="container">
        <div class="tips">一、特别提示</div>
        <div>
          欢迎您使用 “金箱科技”相关服务(包括但不限于金箱科技运
          营的网站、APP、小程序、公众号等形式的服务)（以下简
          称“服务”）。本服务由金箱科技提供，由深圳金箱科技
          有限公司（以下统称“我们”）委托运营。我们将按
          《金箱科技服务协议》（以下简称“本协议”，
          包括未来更新版本）的约定，向您提供服务。
        </div>
        <div>
          我们在此特别提醒您，在注册成为本服务的用户之前，请
          务必认真仔细阅读、充分理解本协议中全部条款，特别是
          涉及免除或者责任限制的条款，该类条款可能以黑体加粗
          或加下划线的形式提示您重点注意，您可选择接受或不接
          受本协议。当您点击“确认”等按钮，或者您继续注册、登
          录或使用本服务，即表示您对本协议的接受，并同意接受
          本协议全部条款的约束。若您不同意本协议，请您立即停
          止用户注册程序，并可选择不使用我们的服务。
          本协议约定金箱科技与用户之间关于“金箱科技”服务的权
          利义务。“用户”是指注册、登录、使用本服务的个人、单 位。
        </div>
        <div class="tips">
          本协议可由金箱科技随时更新，更新后的协议条款一旦公
          布即代替原来的协议条款，恕不再另行通知，用户可在本
          用户端中查阅最新版协议条款。在修改协议条款后，如果
          用户不接受修改后的条款，请立即停止使用金箱科技提供
          的服务，用户继续使用金箱科技提供的服务将被视为接受 修改后的协议。
        </div>
      </div>
      <div class="container">
        <div class="tips">二、账号注册</div>
        <div>
          1、您可直接享受本用户端提供的公共服务，但在使用企业
          或个人服务前需注册金箱科技账号。如您以个人用户的身份
          登录本服务，您应当使用尚未与本服务绑定的手机号码注册
          并绑定本服务的账号。我们可能根据用户需求或产品需要， 更新账号注册方式
        </div>
        <div>
          2、如果您存在被我们封禁的先例，或依据我们的审核规则
          有不适合注册的理由，我们将拒绝您的注册申请
        </div>
        <div>
          3、在您注册及使用本服务时,我们需要收集您的个人信息
          以便我们可以在必要时联系您,和为您提供更好的使用体验。
          我们具体收集的个人信息及处理方式请参考 《金箱科技个人信息保护政策》。
        </div>
      </div>
      <div class="container">
        <div class="tips">三、账户安全</div>
        <div>
          1、当您注册成功,成为本服务的用户,将得到一个用户名和
          密码,并可以使用该用户名及密码随时进行登录。
        </div>
        <div>
          2、您应当对您的用户名和密码加以妥善保管,切勿告知他人。 同时，您同意：
        </div>
        <div>
          （1）对因账号信息保管不善而造成的全部等账号安全事件
          及相关损失，承担全部责任；
        </div>
        <div>
          （2）如您以金箱科技网站平台用户的身份登录，那么以您
          的用户名进行的所有活动和事件均为您所在公司、 企业等的组织行为；
        </div>
        <div>
          （3）不得以任何形式擅自转让或授权第三方使用您的用户 名等账号信息。
        </div>
        <div>
          3、如果您的密码发生泄漏,有可能导致一系列不利后果。
          因此，不管任何原因导致您的密码和账户安全受到威胁,
          您应该立即和我们取得联系,以避免不必要的损失
        </div>
      </div>
      <div class="container">
        <div class="tips">四、用户声明与保证</div>
        <div>
          1、您承诺，您系具有完全民事行为能力的民事主体,且具有
          达成交易履行其义务的能力。
        </div>
        <div>
          2、您承诺，您在注册时提供的资料属实,并保证我们可以通
          过您提供的联系方式与您取得联系。同时,您应当在相关资料
          发生变更时及时更新注册资料
        </div>
        <div>
          3、您承诺，使用本服务过程中所制作、上载、复制、发布、
          传播的任何内容,包括但不限于账号头像、名称、用户说明等
          注册信息及认证资料,或文字、语音、图片、视频、图文等
          发送、回复和相关链接页面,以及其他使用账号或本服务所
          产生的内容,不得违反国家相关法律制度,包含但不限于 如下原则：
        </div>
        <div>(1)违反宪法所确定的基本原则的；</div>
        <div>(2)危害国家安全,泄露国家秘密,颠覆国家政权,破坏国家统一；</div>
        <div>(3)损害国家荣誉和利益的；</div>
        <div>(4)煽动民族仇恨、民族歧视,破坏民族团结的；</div>
        <div>(5)破坏国家宗教政策,宣扬邪教和封建迷信的；</div>
        <div>(6)散布谣言,扰乱社公秩序,破坏社会稳定的；</div>
        <div>(7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪</div>
        <div>(8)侮辱或者诽谤他人,侵害他人合法权益的；</div>
        <div>(9)含有法律、行政法规禁止的其他内容的。</div>
        <div>
          4、您不得利用本服务的账号或本服务制作、上载、复制、
          发布、传播干扰本产品的正常运营,以及侵犯其他用户
          或第三方合法权益的内容：
        </div>
        <div>(1)含有任何性或性暗示的；</div>
        <div>(2)含有辱骂、恐吓、威胁内容的；</div>
        <div>(3)含有骚扰、垃圾广告、恶意信息、诱骗信息的；</div>
        <div>(4)涉及他人隐私、个人信息或资料的；</div>
        <div>(5)侵害他人名誉权、肖像权、知识产权、商业秘密 等合法权利的；</div>
        <div>
          (6)含有其他干扰本服务正常运营和侵犯其他用户或第三方
          合法权益内容的信息。
        </div>
      </div>
      <div class="container">
        <div class="tips">五、服务的终止</div>
        <div>
          1、当发生下列任何一种情况,我们有权单方面终止向您提供
          本服务，而无需对您承担责任，由此造成损失由您自行承担：
        </div>
        <div>（1）您违反本服务协议相关约定；</div>
        <div>（2）您直接或间接或以他人名义注册为用户；</div>
        <div>
          （3）您提交的联系方式已失效，自您在收到我们更新通知三
          个工作日后，仍未能提供有效的联系方式；
        </div>
        <div>（4）存在通过程序或人工方式进行刷量或作弊行为；</div>
        <div>（5）您提供的数据或信息中含有虚假内容；</div>
        <div>（6）您明示不愿接受本协议的更新条款；</div>
        <div>（7）其他我们认为需要中断或终止服务的情况。</div>
        <div>
          2、服务终止后，我们没有义务为您保留原账号中或与之相关
          的任何信息，也没有义务转发任何信息给您或第三方。
        </div>
        <div>
          3、您理解并同意，即便在本协议终止及用户的服务被终止 后，我们仍有权：
        </div>
        <div>（1）在法律法规允许的范围内，继续保存您的用户信息；</div>
        <div>
          （2）继续向您主张在其使用本服务期间因违反法律法规、
          本协议及平台规则而应承担的责任。
        </div>
      </div>
      <div class="container">
        <div class="tips">六、服务的变更、中断</div>
        <div>
          1、鉴于网络服务的特殊性，您同意我们会变更、中断部分
          或全部的网络服务，并有可能删除您在使用过程中提交的
          任何资料，而无需通知您，也无需对任何您或任何第三方 承担任何责任。
        </div>
        <div>
          2、我们会定期或不定期地对提供网络服务的平台进行检测
          或者更新，如因此类情况而造成网络服务在合理时间内的
          中断，我们无需为此承担任何责任。
        </div>
      </div>
      <div class="container">
        <div class="tips">七、服务条款的更新</div>
        <div>
          1、我们将根据实际需要不时更新本服务条款的任何内容，
          一旦本服务条款的任何内容发生变动，我们将会通过适当
          方式向您提示修改内容。如果我们在金箱科技中公布修改
          之后的协议内容，我们不再另行单独通知您。
        </div>
        <div>
          2、在本协议条款更新后，如果您继续使用本服务，则表示
          您同意更新后的协议条款。如果您不同意，有权停止使用 网络服务。
        </div>
      </div>
      <div class="container">
        <div class="tips">八、免责与赔偿声明</div>
        <div>
          1、若我们已经明示服务提供方式发生变更，并提醒您应当
          注意相关事项，您未按要求操作所产生的一切后果由您 自行承担。
        </div>
        <div>
          2、您明确同意，您使用我们的服务所存在的风险将完全由
          其您自行承担，因其使用我们的服务而产生的一切后果也 由您自行承担。
        </div>
        <div>
          3、您同意保障和维护我们及其他用户的利益，由于您在
          使用本服务有违法、不真实、不正当、侵犯第三方合法权益
          的行为，或您违反本协议项下的任何条款而给我们及任何
          其他第三方造成损失，您同意承担由此造成的损害赔偿责任。
        </div>
      </div>
      <div class="container">
        <div class="tips">九、隐私声明</div>
        <div>
          您确认已经详细了解《金箱科技个人信息保护政策》的内容，
          并同意我们将根据该政策处理您的个人信息和隐私。
        </div>
      </div>
      <div class="container">
        <div class="tips">十、其他</div>
        <div>
          1、我们郑重提醒您注意本协议中免除我们责任和限制您权利
          的条款，请您仔细阅读，自主考虑风险。
        </div>
        <div>
          2、本协议的效力、解释及纠纷的解决，适用于中华人民共和
          国法律。若您和我们之间发生任何纠纷或争议，首先应友好
          协商解决，协商不成的，您同意将纠纷或争议提交我们住
          所地有管辖权的人民法院管辖。
        </div>
        <div>
          3、本协议的任何条款无论因何种原因无效或不可执行，其余
          条款仍有效，对双方具有约束力。
        </div>
        <div>
          4、本协议未明示授权的其他权利仍由我们保留，您在行使这
          些权利时须另外取得我们的书面许可。我们如果未行使前述
          任何权利，并不构成对该权利的放弃。
        </div>
      </div>
      <div class="documentName">
        文档名称：
        <div>金箱科技用户服务协议</div>
      </div>
      <div class="updateDate">版本更新日期：2022-8-26</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userAgreement",

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
@import "./agreement.less";
</style>
